import type { UserRole } from "@cv-screener/shared";

export function roleLabel(role: UserRole): string {
  if (role === "SuperAdmin") return "Super Admin";
  if (role === "Recruiter") return "Hiring Manager";
  return role === "Viewer" ? "Reviewer" : role;
}

export function assignableRolesFor(role: UserRole): UserRole[] {
  if (role === "SuperAdmin") return ["SuperAdmin", "Admin", "Recruiter", "Viewer"];
  if (role === "Admin") return ["Admin", "Recruiter", "Viewer"];
  if (role === "Recruiter") return ["Recruiter", "Viewer"];
  return [];
}

export function canManageRole(actorRole: UserRole, targetRole: UserRole): boolean {
  return assignableRolesFor(actorRole).includes(targetRole);
}

export function hasAdminCapabilities(role: UserRole): boolean {
  return role === "SuperAdmin" || role === "Admin";
}

export function canViewApplicationJson(role: UserRole): boolean {
  return role === "SuperAdmin";
}
